import React from "react"
import { connect } from "../../utils"
import Body from "./Body"
import Row from "./Row"
import Content from "./Content"
import TextView from "./TextView"
import Avatar from "./AvatarView"
import ImageView from "./ImageView"
import ImageTextView from "./ImageTextView"
import DividerView from "./DividerView"
import CarouselView from "./CarouselView"
import FlatButtonView from "./FlatButtonView"
import IconButtonView from "./IconButtonView"
import FAButtonView from "./FAButtonView"
import ProductListView from "./ProductListView"
import EmptyView from "./EmptyView"
import YoutubeView from "./YoutubeView"
import ContentCarousel from "./ContentCarousel"
import RowCarousel from "./RowCarousel"
import CarouselAnimationView from "./CarouselAnimationView"
import DealGroupView from "./DealGroupView"
const LayoutHandler = ({ readOnly, ...props }) => {
  //console.log(props);
  const component = dataComponent({ ...props })
  if (component[props.type]) {
    return component[props.type]
  } else {
    return <div />
  }
}
const dataComponent = ({ ...props }) => {
  return {
    Body: <Body {...props} />,
    Row: <Row {...props} />,
    RowCarousel: <RowCarousel {...props} />,
    Content: <Content {...props} />,
    ContentCarousel: <ContentCarousel {...props} />,
    TextView: <TextView {...props} />,
    DividerView: <DividerView {...props} />,
    AvatarView: <Avatar {...props} />,
    ImageView: <ImageView {...props} />,
    ImageTextView: <ImageTextView {...props} />,
    CarouselView: <CarouselView {...props} />,
    FlatButtonView: <FlatButtonView {...props} />,
    IconButtonView: <IconButtonView {...props} />,
    FAButtonView: <FAButtonView {...props} />,
    ProductListView: <ProductListView {...props} />,
    YoutubeView: <YoutubeView {...props} />,
    CarouselAnimationView: <CarouselAnimationView {...props} />,
    EmptyView: <EmptyView {...props} />,
    DealGroupView: <DealGroupView {...props} />,
  }
}

export default connect("readOnly")(LayoutHandler)



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/index.js